var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"static-page"},[_c('ContentBlock',{attrs:{"breadcrumbs-title":_vm.pageData ? _vm.pageData.title : '',"data":_vm.pageData,"is-has-aside":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }